<template>
	<div class="nav">
		<a class="logo" href="#/home"><img src="@/assets/logo.png"></a>
		<div class="search">
			<input type="search" v-model='keys' class='input' placeholder='请输入您要搜索的内容' @keyup.enter='search'>
			<Button @click='search' type='text' class='search-btn' slot="suffix" ><Icon type="ios-search" color='#BD8BCA' /></Button>
		</div>
		<div class='menu-btn' @click='trigerDrawer()'><Icon size='30' color='#B176C5' type="md-menu" /></div>
		<newCustomer :value='newValue' @close='close'  @login='goLogin' />
		<Modal v-model="showModal" footer-hide>
        	<div class="modal-content">
        		<div v-html='modalContent.Content'></div>
        	</div>
	    </Modal>
	    <Modal v-model="showFeedbackModal" title='留言反馈' :styles='{width:"640px",top:"0"}'  footer-hide>
        	<Feedback v-if='showFeedbackModal'/>
	    </Modal>
	    <Drawer width='80' title="Basic Drawer" :closable="false" v-model="showDrawer" class='drawer'>
	        <div slot='header' class="header">
	        	<template v-if='isLogin'>
	        		<div class="user"><p class="name">{{userInfo.value.binding.name}}({{userInfo.value.binding.register.vip_no}})</p></div>
					<div @click='logout' class="logout-btn"><Icon size='25' type="md-exit"/>退出登录</div>
	        	</template>
	        	<template v-else>
	        		<div class="reg-btn" @click='goReg'><span class="zh">创建账户</span><br><span class="en">(Account Registration)</span></div>
	        		<div class="login-btn" @click='goLogin(false)'><span class="zh">登录</span><br><span class="en">(Log-in MyŌ)</span></div>
	        	</template>
	        </div>
	        <div class="icon-btns">
	        	<div @click='href(item)' class="icon-btn" v-for='(item,index) in rightMenus'>
					<img :src="item.Icon" alt="" class="icon">
					<span class="title"><span class="zh">{{item.Label}}</span><br><span class="en">{{item.LabelEN}}</span>	
					</span>
					<Badge :count="cartCount" type="primary"  :offset='[-70,-22]' v-if='item.Code=="WSFT_Shopcart"'>
       					<a  class="demo-badge"></a>
    				</Badge>
				</div>
				
	        </div>
	        <div class="items">
	        	<Menu :theme="'light'" width='300' accordion :active-name='activeCode'>
	        		<template v-if='checkPermission(item.RoleCode)' v-for='(item,index) in leftMenus'>
	        			<Submenu v-if='item.Childs.length' :name="item.Code" :key='item.Code'>
	        				<p slot="title"><span @click.stop='href(item)' class="zh">{{item.Label}}</span>&nbsp;&nbsp;<span @click.stop='href(item)' class="en">{{item.LabelEN}}</span></p>
	        				<template v-if='item.Code !="WSFT_Product"'>
	        					<MenuItem v-if='checkPermission(item1.RoleCode)' @click.native='href(item1)'  v-for='(item1,index) in item.Childs' :key='item1.Code' :name='item1.Code'>
		        					<span class="zh">{{item1.Label}}</span>&nbsp;&nbsp;<span class="en">{{item1.LabelEN}}</span>
		        				</MenuItem>
	        				</template>
	        				<template v-else>
	        					<template v-for='pmenu in productMenuTree'>
	        						<Submenu :key='pmenu.Code' :name='pmenu.Code' v-if='pmenu.Childs.length'>
	        							<p slot="title"><span @click.stop='href(pmenu)' class="zh">{{pmenu.Name}}</span>&nbsp;&nbsp;<span @click.stop='href(pmenu)' class="en">{{item.NameEN}}</span></p>
	        							<MenuItem v-for='psubmenu in pmenu.Childs' :key='psubmenu.Code' :name='psubmenu.Code' @click.native='href(psubmenu)'  >
				        					<span class="zh">{{psubmenu.Name}}</span>&nbsp;&nbsp;<span class="en">{{psubmenu.NameEN}}</span>
				        				</MenuItem>
	        						</Submenu>
	        						<MenuItem :key='pmenu.Code' :name='pmenu.Code' v-else @click.native='href(pmenu)'  >
			        					<span class="zh">{{pmenu.Name}}</span>&nbsp;&nbsp;<span class="en">{{pmenu.NameEN}}</span>
			        				</MenuItem>
	        					</template>
	        				</template>
	        			</Submenu>
	        			<MenuItem @click.native='href(item)' v-else :name="item.Code" :key='item.Code'><span class="zh">{{item.Label}}</span>&nbsp;&nbsp;<span class="en">{{item.LabelEN}}</span></MenuItem>
	        		</template>
	        	</Menu>
			</div>
	    </Drawer>
	</div>
</template>

<script>
	import mixin from './mixin.js';
	export default {
		mixins:[mixin],
	}
</script>

<style lang='scss' scoped>
	@import '@/style/mixin';
	@import '@/style/common';
	.nav {
		z-index:9999;
		width: 100vw;
		background-color: rgba(255,255,255,0.8);
		// border-bottom: 1px solid rgba(238, 238, 238, 1);
		box-shadow: 0 0 5px 1px rgba(0, 0, 0, .2);
		height: 2rem;
		display: flex;
		align-items: center;
		position: fixed;
		.logo {
			margin: 0 0.3rem;
			height: 0.6rem;
			width: auto;
			img {
				height: 0.6rem;
			}
		}
		.search {
			flex: 1;
			display:flex;
			position:relative;
			.input {
				width: 100%;
				height:1.4rem;
				margin: auto;
				border-radius: 40px;
				outline:none;
				padding-left: 10px;
				padding-right: 31px;
				border: 1px solid #ccc;
				// max-width: 600px;
				display: block;
			}
			.search-btn {
				position: absolute;
				right: 0;
				&:hover,&:focus {
					outline: none;
					background-color: transparent;
					box-shadow:none;
				}
			}
		}
		.menu-btn {
			padding: 0 10px;
		}
	}
	.modal-content {
		margin:20px;
		display:flex;
		flex-direction: column;
		.item {
			display:flex;
			margin:10px 0;
			@include fontSize($font-size-16);
			.label {
				width:100px;
			}
			.value {
				flex:1;
			}
		}
		a {
			color:#333;
		}
		a:hover {
			color:$theme-color;
		}
	}
	.drawer {
		::v-deep .ivu-drawer-body {
			padding: 0;
		}
		.header {
			display: flex;
			align-items:center;
			justify-content: space-between;
			.logout-btn {
				display:flex;
				align-items:center;
			}
			.reg-btn,.login-btn {
				text-align: center;
				color:$theme-color;
			}
		}
		.icon-btns {
			padding:20px 10px;
			display:flex;
			justify-content: space-around;
			.icon-btn {
				font-size: 12px;
				// flex:1;
				display:flex;
				flex-direction: column;
				align-items:center;
				justify-content: space-around;
				text-align: center;
				.icon {
					display: block;
					margin: auto;
					width: 30px;
					margin-bottom: 5px;
				}
			}
		}
	}
	.items {
		::v-deep .ivu-menu-vertical.ivu-menu-light:after {
			left: 0;
			right: unset;
		}
		::v-deep .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after {
		    left: 0;
		    width: 3px;
			right: unset;
		}
	}
	@keyframes stretch-width {
		0% {
			width: 0;
		}
		100% {
			width: 100%;
		}
	}
	@keyframes stretch-height {
		0% {
			height: 0;
		}
		100% {
			height: auto;
		}
	}
</style>